// const blogTagSlider = document.querySelector('.block__blog-breadcrumb-category ul');
// let isDown = false;
// let startX;
// let scrollLeft;

// blogTagSlider.addEventListener('mousedown', (e) => {
//   isDown = true;
//   blogTagSlider.classList.add('active');
//   startX = e.pageX - blogTagSlider.offsetLeft;
//   scrollLeft = blogTagSlider.scrollLeft;
// });
// blogTagSlider.addEventListener('mouseleave', () => {
//   isDown = false;
//   blogTagSlider.classList.remove('active');
// });
// blogTagSlider.addEventListener('mouseup', () => {
//   isDown = false;
//   blogTagSlider.classList.remove('active');
// });
// blogTagSlider.addEventListener('mousemove', (e) => {
//   if(!isDown) return;
//   e.preventDefault();
//   const x = e.pageX - blogTagSlider.offsetLeft;
//   const walk = (x - startX) * 3; //scroll-fast
//   blogTagSlider.scrollLeft = scrollLeft - walk;
// });


const blogBreadCarousel = document.querySelector(".block__blog-breadcrumb-slider");
if (blogBreadCarousel) {
  var swiper = new Swiper(blogBreadCarousel, {
    slidesPerView: "auto",
    spaceBetween: 32,
    allowTouchMove: true,
    disableOnInteraction: true,
    navigation: {
      nextEl: ".blog-breadcrumb-arrow-next",
      prevEl: ".blog-breadcrumb-arrow-prev",
    },
    pagination: {
      el: '.blog-breadcrumb-pagination',
      clickable: true,
  },
    breakpoints: {
      748: {
        spaceBetween: 20,
      },
      1600: {
        spaceBetween: 32,
      },
    },
  });
}
